import * as S from './styles';
import { useTheme } from 'styled-components';
import Avatar from '../../Avatar';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';
import { Redirect } from '../../../utils/routeUtil';
import { RootStateBase } from '../../../store/baseStore';
import { connectState, PropsFromRedux } from "base/src/utils/reduxUtil";

const connector = connectState(
  (state: RootStateBase) => ({
    userData: state.UtilReducer.UserData,
  })
);

interface ProfileOptionsHeaderProps extends PropsFromRedux<typeof connector> {}

export function ProfileOptionsHeader (props : ProfileOptionsHeaderProps) {
  const theme = useTheme();

  function goToAuth(){
    Redirect(GetAuthRoute())
  }

  return (
    <S.Container onClick={goToAuth}>
      <Avatar
        src={props.userData?.ImagemUrl}
        borderColor={theme.colors.primary}
        size='sm'
        alt='top'
        fallBack='C'
      />
      <S.ProfileContainer>
        <S.ProfileName>{`${props.userData?.NomeExibicao}`}</S.ProfileName>
        <S.UserRole>{props.userData?.Email}</S.UserRole>
      </S.ProfileContainer>
    </S.Container>
  )
}

export default connector(ProfileOptionsHeader);